// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3y_9b","header":"MergedInvoice_header__1gtU2"};